// import {initLoad} from './load';
import kuToolEvent, {EventKeys} from '../eventBus/bus';
import {doc, selectionChangeCallback} from './doc';

function on() {
    kuToolEvent.on(EventKeys.DOC_SELECTION, (event) => {
        doc.setDocSelectionData(event);
        selectionChangeCallback(event);
    });

    kuToolEvent.on(EventKeys.ROOT_READY, () => {
        // console.log('ROOT_READY');
        // 加载js
        // initLoad();
    });
}

// 注册事件
on();
